import React from 'react'
import { Link } from 'react-router-dom'
import {
  hasUserPermission,
  hasUserPermissionOnMegaMenuGroupItem,
} from '../../utils/permissionHelper'

export const users = [
  {
    label: 'Users',
    link: '/user',
    permission: 'user_read',
  },
  {
    label: 'User Roles',
    link: '/user_role',
    permission: 'user_role_read',
  },
  {
    label: 'User Teams',
    link: '/user_team',
    permission: 'user_team_read',
  },
  {
    label: 'Manager Approvals',
    link: '/manager_approval?filter=approval_required',
    permission: 'manager_approval_read',
  },
  {
    label: 'Bank Change Verification Approval Queue',
    link: '/decision_logic_approval_queue?filter=pending_approval',
    permission: 'manager_approval_read',
  },
  {
    label: 'User Field Restrictions',
    link: '/user_field_restriction',
    permission: 'user_field_restriction_read',
  },
  // {
  //   label: 'User Role Field Restrictions',
  //   link: '/user_role_field_restriction',
  //   permission: 'user_role_field_restriction_read',
  // },
  // {
  //   label: 'Tag User Role Restrictions',
  //   link: '/tag_user_role_restriction',
  //   permission: 'tag_user_role_restriction_read',
  // },
]

export const financial_setups = [
  {
    label: 'Portfolios',
    link: '/portfolio',
    permission: 'portfolio_read',
  },
  {
    label: 'Loan Agreements',
    link: '/loan_agreement',
    permission: 'loan_agreement_read',
  },
  {
    label: 'Programs',
    link: '/program',
    permission: 'program_read',
  },
  {
    label: 'Payment Processors',
    link: '/payment_processor',
    permission: 'payment_processor_read',
  },
  {
    label: 'Payment Processor Split',
    link: '/payment_processor_split',
    permission: 'payment_processor_split_read',
  },
  {
    label: 'Bank Verification Provider Split',
    link: '/bank_verification_provider_split',
    permission: 'bank_verification_provider_split_read',
  },
]

export const financial_management = [
  {
    label: 'Payment Batches',
    link: '/payment_batch',
    permission: 'payment_batch_read',
  },
  {
    label: 'Payment Returns',
    link: '/payment_return',
    permission: 'payment_return_read',
  },
  {
    label: 'Payment Return Files',
    link: '/payment_return_file',
    permission: 'payment_return_file_read',
  },
  {
    label: 'Lead Payments',
    link: '/lead_payment',
    permission: 'lead_payment_read',
  },
  {
    label: 'Payment Plan Payments',
    link: '/payment_plan_payment',
    permission: 'payment_plan_payment_read',
  },
  {
    label: 'Collection Batch Placements',
    link: '/collection_batch_placement',
    permission: 'collection_batch_placement_read',
  },
  {
    label: 'Payment Logs',
    link: '/payment_log',
    permission: 'payment_log_read',
  },
  {
    label: 'Payment Blocks',
    link: '/payment_block',
    permission: 'payment_block_read',
  },
  {
    label: 'Processor Company Excluded States',
    link: '/processor_company_excluded_state',
    permission: 'processor_company_excluded_state_read',
  },
]

export const customer_tools = [
  {
    label: 'SSV Customer Step Completions',
    link: '/ssv_customer_step_completion',
    permission: 'ssv_customer_step_completion_read',
  },
  {
    label: 'SSV Customer Responses',
    link: '/ssv_customer_response',
    permission: 'ssv_customer_response_read',
  },
  {
    label: 'Bankruptcy Monitoring',
    link: '/bankruptcy_monitoring',
    permission: 'bankruptcy_monitoring_read',
  },
  {
    label: 'Sensitive Pii View Log',
    link: '/sensitive_pii_view_log',
    permission: 'sensitive_pii_view_log_read',
  },
  {
    label: 'Documents',
    link: '/document',
    permission: 'document_read',
  },
  {
    label: 'Lead Signatures',
    link: '/lead_signature',
    permission: 'lead_signature_read',
  },
  {
    label: 'Verifications',
    link: '/verification',
    permission: 'verification_read',
  },
  {
    label: 'Verification Responses',
    link: '/verification_response',
    permission: 'verification_response_read',
  },
  {
    label: 'DMCs',
    link: '/dmc',
    permission: 'dmc_read',
  },
  {
    label: 'Loan DMCs',
    link: '/loan_dmc',
    permission: 'loan_dmc_read',
  },
  {
    label: 'Power of Attorney Customers',
    link: '/power_of_attorney_customer',
    permission: 'power_of_attorney_customer_read',
  },
  {
    label: 'Cease & Desists',
    link: '/cease_and_desist',
    permission: 'cease_and_desist_read',
  },
  {
    label: 'Customer Reassignment',
    link: '/customer_reassignment',
    permission: 'customer_reassignment_read',
  },
]

export const marketing_tools = [
  {
    label: 'Campaign',
    link: '/campaign',
    permission: 'campaign_read',
  },
  {
    label: 'Campaign Batch',
    link: '/campaign_batch',
    permission: 'campaign_batch_read',
  },
  {
    label: 'Send Emails',
    link: '/send_email',
    permission: 'manual_send_mail_marketing',
  },
  {
    label: 'Add Promotion Code & Customers',
    link: '/promotion_code_customer',
    permission: 'add_promotion_code_and_customer',
  },
  {
    label: 'Promotions',
    link: '/promotion',
    permission: 'promotion_read',
  },
  {
    label: 'Promotion Groups',
    link: '/promotion_group',
    permission: 'promotion_group_read',
  },
  {
    label: 'Promotion Codes',
    link: '/promotion_code',
    permission: 'promotion_code_read',
  },
  {
    label: 'Queue Bulk Email Jobs',
    link: '/queue_bulk_email_job',
    permission: 'queue_bulk_email_job_read',
  },
  {
    label: 'Queue Bulk Promotion Code Jobs',
    link: '/queue_bulk_promotion_code_job',
    permission: 'queue_bulk_promotion_code_job_read',
  },
  {
    label: 'Queue Uncollectible Loan Jobs',
    link: '/queue_uncollectible_loan_job',
    permission: 'queue_uncollectible_loan_job_read',
  },
  {
    label: 'Bulk Uncollectible Loan Release',
    link: '/bulk_uncollectible_loan_release',
    permission: 'queue_uncollectible_loan_job_read',
  },
  {
    label: 'Reward Points',
    link: '/customer_reward',
    permission: 'customer_reward_read',
  },
  {
    label: 'Portfolio Design',
    link: '/portfolio_design',
    permission: 'portfolio_design_read',
  },
  {
    label: 'Portfolio Email Subdomain',
    link: '/portfolio_email_subdomain',
    permission: 'portfolio_email_subdomain_read',
  },
  {
    label: 'Test Strategies',
    link: '/test_strategy',
    permission: 'test_strategy_read',
  },
  {
    label: 'Test Strategy Segments',
    link: '/test_strategy_segment',
    permission: 'test_strategy_segment_read',
  },
  {
    label: 'Test Strategy Segment Customers',
    link: '/test_strategy_segment_customer',
    permission: 'test_strategy_segment_customer_read',
  },
]

export const messaging = [
  {
    label: 'Templates',
    link: '/template',
    permission: 'template_read',
  },
  {
    label: 'Template Placeholders',
    link: '/template_placeholder',
    permission: 'template_placeholder_read',
  },
  {
    label: 'Email Messages',
    link: '/customer_email_message',
    permission: 'customer_email_message_read',
  },
  {
    label: 'SMS Messages',
    link: '/customer_sms_message',
    permission: 'customer_sms_message_read',
  }
]

export const lists = [
  {
    label: 'Modules',
    link: '/module',
    permission: 'module_read',
  },
  {
    label: 'Dropdowns',
    link: '/dropdown',
    permission: 'dropdown_read',
  },
  { label: 'Tags', link: '/tag', permission: 'tag_read' },
  {
    label: 'Interactions Dispositions',
    link: '/interaction_disposition',
    permission: 'interaction_disposition_read',
  },
  {
    label: 'Banks',
    link: '/bank',
    permission: 'bank_read',
  },
  {
    label: 'Bank Accounts',
    link: '/bank_account',
    permission: 'bank_account_read',
  },
  {
    label: 'Bank Routing Numbers',
    link: '/bank_routing_number',
    permission: 'bank_routing_number_read',
  },
  {
    label: 'Bank Change',
    link: '/bank_change',
    permission: 'bank_change_read',
  },
  {
    label: 'Bank Transactions',
    link: '/bank_transaction',
    permission: 'manager_approval_read',
  },
  {
    label: 'Bank Transactions Provider Calls',
    link: '/bank_transaction_provider_call',
    permission: 'manager_approval_read',
  },
  {
    label: 'Zip Codes',
    link: '/zip_code',
    permission: 'zip_code_read',
  },
]

export const developer_tools = [
  {
    label: 'System Jobs',
    link: '/log_system_job',
    permission: 'log_system_job_read',
  },
  {
    label: 'System Action Audits',
    link: '/system_action_audit',
    permission: 'system_action_audit_read',
  },
  {
    label: 'System Migrations',
    link: '/system_migration',
    permission: 'system_migration_read',
  },
  {
    label: 'Queue Report Files',
    link: '/queue_report_file',
    permission: 'queue_report_file_read',
  },
  // {
  //   label: 'Change Logs',
  //   link: '/change_log',
  //   permission: 'change_log_read',
  // },
  {
    label: 'Portfolio States',
    link: '/portfolio_state',
    permission: 'portfolio_state_read',
  },
  {
    label: 'Notifications',
    link: '/notification',
    permission: 'notification_read',
  },
  {
    label: 'Notification Subscriptions',
    link: '/notification_subscription',
    permission: 'notification_subscription_read',
  },
  // {
  //   label: 'Tag Related Tags',
  //   link: '/tag_related_tag',
  //   permission: 'tag_related_tag_read',
  // },
  // {
  //   label: 'Style Guide',
  //   link: '/style_guide',
  //   permission: 'style_guide_read',
  // },
]

export const miscellaneous_items = [
  // {
  //   label: 'Customer Tags',
  //   link: '/tag_customer',
  //   permission: 'tag_customer_read',
  // },
  // {
  //   label: 'Note Tags',
  //   link: '/tag_note',
  //   permission: 'tag_note_read',
  // },
  // {
  //   label: 'Loan Tags',
  //   link: '/tag_loan',
  //   permission: 'tag_loan_read',
  // },
  {
    label: 'Factortrust Activity Audits',
    link: '/factortrust_activity_audit',
    permission: 'factortrust_activity_audit_read',
  },
  {
    label: 'Clarity Activity Audits',
    link: '/clarity_activity_audit',
    permission: 'clarity_activity_audit_read',
  },
  {
    label: 'Loan Settlement Offer',
    link: '/loan_settlement_offer',
    permission: 'loan_settlement_offer_read',
  },
  {
    label: 'Module Queue',
    link: '/module_queue',
    permission: 'module_queue_read',
  },
  {
    label: 'Loans Requiring Attention',
    link: '/loans_requiring_attention',
    permission: 'loans_requiring_attention_read',
  },
]

export const ringcentral_items = [
  {
    label: 'Completed Contacts',
    link: '/rc_completed_contact',
    permission: 'rc_completed_contact_read',
  },
  {
    label: 'Custom Data',
    link: '/rc_custom_data',
    permission: 'rc_custom_data_read',
  },
  {
    label: 'Dialer Queue',
    link: '/rc_dialer_queue',
    permission: 'rc_dialer_queue_read',
  },
  {
    label: 'Interactions',
    link: '/rc_interaction',
    permission: 'rc_interaction_read',
  },
  {
    label: 'Interaction Participants',
    link: '/rc_interaction_participant',
    permission: 'rc_interaction_participant_read',
  },
  {
    label: 'Interaction Segments',
    link: '/rc_interaction_segment',
    permission: 'rc_interaction_segment_read',
  },
  {
    label: 'Interaction Voice Stages',
    link: '/rc_interaction_voice_stage',
    permission: 'rc_interaction_voice_stage_read',
  },
  {
    label: 'Skills',
    link: '/rc_skill',
    permission: 'rc_skill_read',
  },
  {
    label: 'Call Recording',
    link: '/rc_calling_recording',
    permission: 'rc_calling_recording_read',
  },
  {
    label: 'Portfolio Routing',
    link: '/portfolio_routing',
    permission: 'portfolio_routing_read',
  },
  {
    label: 'Transfer Log',
    link: '/rc_transfer_log',
    permission: 'rc_transfer_log_read',
  }
]

export const test_items = [
  {
    label: 'Test Setup',
    link: '/test_setup',
    permission: 'portfolio_read',
  }
]

export const dev_items = [
  {
    label: 'Dev Toolbox',
    link: 'dev_toolbox',
    permission: 'is_dev'
  },
  {
    label: 'System Messages',
    link: 'system_message',
    permission: 'system_message_read'
  }
]

export default function NavAdmin(props) {
  return (
    <div className="navbar-dropdown lox-navigation-bar__content__dropdown is-block">
      <div className="m-0 p-3 is-size-7 lox-navigation-bar__content__dropdown__container">
        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, users) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">User</h2>
            {users.map(
              (user, i) =>
                hasUserPermission(props.userPermissions, user.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${user.link}`}
                    onClick={props.onLink}
                    key={user.permission}
                  >
                    {user.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, financial_setups) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">
              Financial Setup
            </h2>
            {financial_setups.map(
              (fs) =>
                hasUserPermission(props.userPermissions, fs.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${fs.link}`}
                    onClick={props.onLink}
                    key={fs.permission}
                  >
                    {fs.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, financial_management) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">
              Financial Management
            </h2>
            {financial_management.map(
              (fm) =>
                hasUserPermission(props.userPermissions, fm.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${fm.link}`}
                    onClick={props.onLink}
                    key={fm.permission}
                  >
                    {fm.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, marketing_tools) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">
              Marketing Tools
            </h2>
            {marketing_tools.map(
              (marketing_tool) =>
                hasUserPermission(props.userPermissions, marketing_tool.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${marketing_tool.link}`}
                    onClick={props.onLink}
                    key={marketing_tool.permission}
                  >
                    {marketing_tool.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, customer_tools) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">
              Customer Tools
            </h2>
            {customer_tools.map(
              (customer_tool) =>
                hasUserPermission(props.userPermissions, customer_tool.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${customer_tool.link}`}
                    onClick={props.onLink}
                    key={customer_tool.permission}
                  >
                    {customer_tool.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, messaging) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">Messaging</h2>
            {messaging.map(
              (m) =>
                hasUserPermission(props.userPermissions, m.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${m.link}`}
                    onClick={props.onLink}
                    key={m.permission}
                  >
                    {m.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, lists) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">Lists</h2>
            {lists.map(
              (list) =>
                hasUserPermission(props.userPermissions, list.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${list.link}`}
                    onClick={props.onLink}
                    key={list.permission}
                  >
                    {list.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, developer_tools) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">
              Developer Tools
            </h2>
            {developer_tools.map(
              (developer_tool) =>
                hasUserPermission(props.userPermissions, developer_tool.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${developer_tool.link}`}
                    onClick={props.onLink}
                    key={developer_tool.permission}
                  >
                    {developer_tool.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, miscellaneous_items) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">
              Miscellaneous
            </h2>
            {miscellaneous_items.map(
              (miscellaneous_item) =>
                hasUserPermission(props.userPermissions, miscellaneous_item.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${miscellaneous_item.link}`}
                    onClick={props.onLink}
                    key={miscellaneous_item.permission}
                  >
                    {miscellaneous_item.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, ringcentral_items) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">
              RingCentral
            </h2>
            {ringcentral_items.map(
              (item) =>
                hasUserPermission(props.userPermissions, item.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${item.link}`}
                    onClick={props.onLink}
                    key={item.permission}
                  >
                    {item.label}
                  </Link>
                )
            )}
          </div>
        )}
        {process.env.REACT_APP_ENVIRONMENT !== 'production' && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">
              Test Data
            </h2>
            {test_items.map(
              (item) =>
                (
                  <Link
                    className="navbar-item"
                    to={`${item.link}`}
                    onClick={props.onLink}
                    key={item.permission}
                  >
                    {item.label}
                  </Link>
                )
            )}
          </div>
        )}
        {hasUserPermission(props.userPermissions, "is_dev") && (
        <div className="mt-2">
          <h2 className="title is-size-5 mb-0 has-text-primary">
            Dev Only
          </h2>
          {dev_items.map(
            (item) =>
              hasUserPermission(props.userPermissions, item.permission) && (
                <Link
                  className="navbar-item"
                  to={`${item.link}`}
                  onClick={props.onLink}
                  key={item.permission}
                >
                  {item.label}
                </Link>
              )
          )}
        </div>
      )}
      </div>
    </div>
  )
}
